import React from "react";
import { PropTypes } from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    overflowY: "auto",
    overflowX: "hidden",
    height: "calc(100vh - 70px)",
    width: "100%"
  }
}));
const ExpertConversationContainer = ({
  children
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, children);
};
export default ExpertConversationContainer;
ExpertConversationContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array])
};